/* ================================================== */
/* UTILS → ratio
/* ================================================== */

function fullscreen() {
	$('.js-fullscreen').height($(window).height());
}

$(window).resize(function() {
	fullscreen();
});

document.addEventListener('webkitfullscreenchange', function() {
	fullscreen();
}, false);

window.onorientationchange = function() {
	var orientation = window.orientation;
	fullscreen();
}